import { memo, ReactNode, Ref } from "react";
import cx from "classnames";

import TableBodyRow from "ds/components/Table/Row";

import styles from "./styles.module.css";

type PersonalSettingsSpacesTableBodyRowProps = {
  dataIndex: number;
  children: ReactNode;
  forwardRef?: Ref<HTMLDivElement>;
  className?: string;
};

const PersonalSettingsSpacesTableBodyRow = memo(function PersonalSettingsSpacesTableBodyRow({
  dataIndex,
  children,
  className,
  forwardRef,
  ...props
}: PersonalSettingsSpacesTableBodyRowProps) {
  return (
    <TableBodyRow
      {...props}
      className={cx(styles.row, className)}
      data-index={dataIndex}
      ref={forwardRef}
    >
      {children}
    </TableBodyRow>
  );
});

export default PersonalSettingsSpacesTableBodyRow;
